import React, {PropTypes} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push, goBack } from 'react-router-redux'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline } from "react-google-maps"
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import { Slider, Select, Button, Col, Row, Tooltip } from 'antd';
import {Motion, spring} from 'react-motion';
// LOCAL

// SHARED

import TrashIcon from '../core/components/TrashIcon'
import ModalRoot from '../modal/ModalRoot'
import onMount from '../core/onMount'

import Card, { TitleCard } from '../core/Card'

import { ForwardIcon, Icon, PlusIcon, CarIcon } from '../core/icons'

export const Map = withScriptjs(withGoogleMap((props) =>{
  return (<GoogleMap
    ref={map => map && map.fitBounds(getBounds(formatWaypointsToPolyline(props.locations)))}
    defaultZoom={12}
    // zoom={props.zoom}
    // defaultCenter={{ lat: -34.397, lng: 150.644 }}
    center={getBounds(formatWaypointsToPolyline(props.locations)).getCenter()}
    // mapTypeControlOptions
    // mapTypeControl={false}
    // mapTypeControlOptions={false}
    // mapTypeControl
    options={{
        mapTypeControl: false,
        // mapTypeControlOptions: {
        //   mapTypeIds: [new window.google.maps.MapTypeId.ROADMAP]
        // }, // here´s the array of controls
        // disableDefaultUI: true, // a way to quickly hide all controls
        mapTypeControl: false,
        scaleControl: false,
        zoomControl: props.zoomControl,
        fullscreenControl: false,
        streetViewControl: props.streetViewControl,
        // mapTypeId: 'satellite',
        // zoomControlOptions: {
        //   style: new window.google.maps.ZoomControlStyle.LARGE
        // },

    }}
  >
    <Polyline
      path={formatWaypointsToPolyline(props.locations)}
      options={{
        strokeColor: '#3995FD',//'#39b59e',
        strokeOpacity: 0.8,
        strokeWeight: 8,
      }}
    />

    <Marker
      options={{
        animation: 'drop',
        icon: {
            path: 'M25,42.5c-9.66498,0 -17.5,-7.83502 -17.5,-17.5l0,0c0,-9.66498 7.83502,-17.5 17.5,-17.5l0,0c9.66498,0 17.5,7.83502 17.5,17.5l0,0c0,9.66498 -7.83502,17.5 -17.5,17.5z',
            fillColor: '#FF5166',
            strokeOpacity: 0.5,
            fillOpacity: 1,
            scale: 0.5,
            strokeColor: '#FF5166',
            strokeWeight: 7,
            anchor: new window.google.maps.Point(30,30)
          }
      }}
      position={formatLatLng(props.started_at_coordinate)}
    />
    <Marker position={formatLatLng(props.ended_at_coordinate)}/>


  </GoogleMap>)}
))


export default class MapCard extends React.PureComponent {
  state = {
    selected: null,
    expanded: false
  }

  select = (coord) => {
    this.setState({ selected: coord })
  }

  deselect = () => {
    this.setState({ selected: null })
  }
  resize = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    return (
      <Row gutter={20}>
        <Col xs={14}>
        <Card>
          {/* {this.props.leftCard} */}
          <Button onClick={()=>this.select(this.props.trip.started_at_coordinate)}>select from addr</Button>
          <Button onClick={this.deselect}>deselect</Button>
          <Button onClick={this.resize}>resize</Button>
        </Card>
        </Col>

        <Col xs={10}>
        <Card>
          {/* <Motion style={{x: spring(this.state.expanded ? 500 : 150)}}>
            {({x}) => */}
          <Map
            locations={this.props.trip.locations}
            started_at_coordinate={this.props.trip.started_at_coordinate}
            ended_at_coordinate={this.props.trip.ended_at_coordinate}
            streetViewControl={this.state.resize}
            zoomControl={this.state.resize}
            onMarkerClick={this.selectMember}
            selectedMember={this.state.selectedMember}
            zoom={this.state.expanded? 13 : 11}
            fitBounds={this.handleFitBounds}
            onClose={this.deselect}
            googleMapURL={"https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key="+process.env.REACT_APP_GOOGLE_MAPS_KEY}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={
              <div style={{ height: `${this.state.expanded?500:150}px`, margin: `-20px -20px -${this.state.expanded?20:44}px -20px` }} />
              // <div style={{ height: `${x}px`, margin: '-20px' }} />
            }
            mapElement={<div style={{ height: `100%` }} />}
          />

        {/* }
      </Motion> */}

        </Card>
      </Col>
    </Row>

    )
  }
}

export const getBounds = (path) => {
  if (!window.google) return null
  var bounds = new window.google.maps.LatLngBounds();
  path.forEach(function(e) {
    bounds.extend(e);
  });
  return bounds;
};

export const formatLatLng = (str) => {
  if (str) {
    return {lat: +str.split(',')[0], lng: +str.split(',')[1]}
  } else {
    return {}
  }
}

export const formatWaypointsToPolyline = (waypoints) => waypoints ? waypoints.map(w=> ( {lat: +w.split(',')[0], lng: +w.split(',')[1]} )) : []



// WEBPACK FOOTER //
// ./src/trips/MapCard.js